import React from 'react';
import PropTypes from 'prop-types';
import Avatar from 'material-ui/Avatar';
import { ListItem, ListItemText } from 'material-ui/List';

import { DK_DECIMALS } from '../../../../../../constants/globals';
import { mapStandardParamsToFormulaParams } from '../../../../../../lib/simulations/formulas/stripline';
import { inchToString } from '../../../../../../lib/unitConversions';

export function StriplineParams({
  classes,
  params,
  lengthUnit,
}) {
  const { w, d, t, e, b } = mapStandardParamsToFormulaParams(params);

  return (
    <span>
      <ListItem>
        <Avatar className={classes.paramsAvatar}>
          <span>
            E
            <sub>r</sub>
          </span>
        </Avatar>
        <ListItemText>
          {e.toFixed(DK_DECIMALS)}
        </ListItemText>
      </ListItem>
      <ListItem>
        <Avatar className={classes.paramsAvatar}>
          B 
        </Avatar>
        <ListItemText>
          {inchToString(b, lengthUnit)}
        </ListItemText>
      </ListItem>
      <ListItem>
        <Avatar className={classes.paramsAvatar}>
          S
        </Avatar>
        <ListItemText>
          {inchToString(d, lengthUnit)}
        </ListItemText>
      </ListItem>
      <ListItem>
        <Avatar className={classes.paramsAvatar}>
          W 
        </Avatar>
        <ListItemText>
          {inchToString(w, lengthUnit)}
        </ListItemText>
      </ListItem>
      <ListItem>
        <Avatar className={classes.paramsAvatar}>
          T 
        </Avatar>
        <ListItemText>
          {inchToString(t, lengthUnit)}
        </ListItemText>
      </ListItem>
    </span>
  );
}

StriplineParams.propTypes = {
  classes:    PropTypes.objectOf(PropTypes.string).isRequired,
  params:     PropTypes.objectOf(PropTypes.number).isRequired,
  lengthUnit: PropTypes.string.isRequired,
}

export default StriplineParams;


// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/ResultViewer/SimulationModelModal/ParamsList/StriplineParams.jsx